import { IMaintenanceInfoResponse } from '@/store/api/maintenanceApi';
import { findCategoryForSubCategory } from './maintenance';
import { BuildTicketArgs, UploadLike } from './buildTicketFormData';

export interface MaintenanceSubmitArgs {
  requestType: 'maintenance' | 'it';
  category: string;
  subCategory: string;
  maintenanceInfo: IMaintenanceInfoResponse | undefined;
  location: string;
  problem: string;
  severity: string;
  title: string;
  description: string;
  phoneNumber: string;
  permissionChoice: null | 'yes' | 'no';
  attachments: UploadLike[];
  hasPets?: boolean;
  specialInstructions?: string;
}

/**
 * Pure transform from the maintenance form's raw values to the FormData-builder
 * args. Mirrors the previous inline logic in useMaintenanceSubmit verbatim so it
 * stays behavior-preserving.
 */
export const buildSubmitPayload = (
  args: MaintenanceSubmitArgs,
  userPhone?: string,
): BuildTicketArgs => {
  let finalCategory = '';
  if (args.requestType === 'it') {
    finalCategory = 'IT';
  } else if (args.category) {
    finalCategory = args.category;
  } else if (args.subCategory) {
    finalCategory = findCategoryForSubCategory(args.maintenanceInfo, args.subCategory);
  }
  if (!finalCategory && args.maintenanceInfo?.categories?.length) {
    finalCategory = args.maintenanceInfo.categories[0].name;
  }

  const finalPhoneNumber = args.phoneNumber || userPhone || '';

  let petsDescription: string | undefined;
  if (args.hasPets || args.specialInstructions?.trim()) {
    const parts: string[] = [];
    if (args.hasPets) parts.push('Has pets.');
    if (args.specialInstructions?.trim()) parts.push(args.specialInstructions.trim());
    petsDescription = parts.join(' ');
  }

  return {
    maintenanceInfo: args.maintenanceInfo,
    locationName: args.location,
    categoryName: finalCategory,
    subCategoryName: args.subCategory,
    problemName: args.problem,
    severityName: args.severity,
    description: `${args.title}${args.description ? '\n\n' + args.description : ''}`,
    phoneNumber: finalPhoneNumber,
    permissionChoice: args.permissionChoice,
    attachments: args.attachments,
    petsDescription,
  };
};
